import { useQuery, useQueryClient } from "@tanstack/react-query";
import { EndpointsService } from "../../../../services/endpoints/endpoints.service";
import { PostDischargeProcedureType } from "../../../../models/procedures.model";

export const usePostDischarge = (patientId: number) => {
	const queryClient = useQueryClient();
	const queryKey = ["post-discharge", { patientId }];

	const query = useQuery({
		queryKey: queryKey,

		queryFn: async () => {
			const response = await EndpointsService.dataRetriever.getProcedures({
				config: {
					params: {
						participantId: patientId,
					},
				},
			});

			//Get only the post discharge items
			return response.filter((procedure) =>
				Object.keys(PostDischargeProcedureType).includes(procedure.type)
			);
		},
	});

	return {
		...query,
		retry: 0,
		invalidate: () =>
			queryClient.invalidateQueries({
				queryKey: queryKey,
			}),
	};
};
